// The idea is to refactor generateSearchPath with objectQueryBuilder
// and small helper functions to generate the path
// these functions will be used in the products search pages

import { FILTER_NAMES } from '../product/filterHelper';

const hasMakeModel = (initialParamsMakeModel) => {
  for (const makeName in initialParamsMakeModel) {
    if (
      Array.isArray(initialParamsMakeModel[makeName]) &&
      initialParamsMakeModel[makeName].length > 0
    ) {
      return true;
    }
  }
  return false;
};

const generateMakeAndModelPathParam = (makeModel) => {
  let makes = Object.keys(makeModel).length;
  if (makes === 1) {
    let models = 0;
    Object.values(makeModel).map((item) => {
      models += item.length;
    });
    if (models < 2) {
      let make = Object.keys(makeModel)[0];
      let makeMod = { 'make': make };
      if (models === 1) {
        makeMod.model = makeModel[make][0].replace(/\./g, '-');
      }
      return makeMod;
    }
  }
  return null;
};

const toPagePath = (page, pathTranslations, caller) => {
  const clearPage = caller !== FILTER_NAMES.PAGE || !page || +page === 1;
  if (clearPage) {
    return null;
  }
  const path = pathTranslations.SEARCH_URL_ITEM_PAGE;
  return `${path}-${page}`;
};

/**
 * Converts an availability type to a URL path segment.
 * @param availabilityType string representing the availability type
 * @param pathTranslations object containing path translations
 * @param translate object containing translation functions
 * @returns {string|null}
 * @throws {Error} if translation for the availability type is not found
 */
const toAvailabilityType = (availabilityType, pathTranslations, translate) => {
  const path = pathTranslations?.SEARCH_URL_ITEM_AVAILABILITY;
  const { t, messages } = translate;
  if (!availabilityType) {
    return null;
  }
  const avaliableMsg = messages.productSearch.routes.availabilityType;
  const availabilities = {  buy: avaliableMsg.buy, rent: avaliableMsg.rent };
  const availabilityKey = Object.keys(availabilities)
    .find(key => avaliableMsg[key]?.defaultMessage === availabilityType);
  const typeMessage = t(avaliableMsg[availabilityKey]);
  return `${path}-${typeMessage}`;
};

export {
  toPagePath,
  toAvailabilityType,
  hasMakeModel,
  generateMakeAndModelPathParam
};
